<template>
  <div
    class="like-container"
    :class="{ 'grid-tag': gridTag }"
    @click.stop.prevent="likeVector(vectorId)"
  >
    <div class="icon-container">
      <Icon class="icon" color="#ffffff" :height="30" :width="30" :icon="likeIcon" />
    </div>
    <span v-if="gridTag" class="text">{{ text }}</span>
  </div>
</template>

<script>
import Icon from 'UI/Icon';

export default {
  components: {
    Icon
  },
  props: {
    vectorId: {
      type: Number,
      required: true
    },
    text: {
      type: String,
      required: true
    },
    gridTag: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    isLiked() {
      return this.$store.getters['user/isVectorLiked'](parseInt(this.vectorId));
    },
    likeIcon() {
      return this.isLiked ? 'like-full' : 'like-empty';
    }
  },
  methods: {
    likeVector(idVector) {
      this.$store.dispatch('user/SET_LIKE_VECTOR', {
        idVector,
        isLiked: this.isLiked,
        bvModal: this.$bvModal
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.like-container {
  width: 38px;
  height: 38px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.5);
  cursor: pointer;
  z-index: 2;
  border-radius: 7px;
  margin-top: 10px;
  margin-right: 10px;
  transition: all 0.3s ease-out;
  box-sizing: border-box;
  &:hover {
    background-color: $merchColor;
  }
  &:hover .text {
    right: 37px;
    transform: scaleX(1);
    opacity: 1;
  }
  .icon-container {
    margin-bottom: 10px;
    height: 20px;
    position: absolute;
    right: 0;
    width: 38px;
    display: flex;
    align-content: center;
    .icon {
      height: 100%;
      margin: auto;
    }
  }
  .text {
    font-size: 10px;
    min-width: 10px;
    padding: 10px;
    width: max-content;
    position: absolute;
    height: 38px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: inherit;
    color: #fff;
    transform: scaleX(0);
    border-radius: 7px 0px 0px 7px;
    top: 0;
    right: 38px;
    opacity: 0;
    transform-origin: right center;
    z-index: -1;
    transition: inherit;
    box-sizing: border-box;
  }
}
.grid-tag {
  background-color: hsla(0, 0%, 100%, 0.5);
  .text {
    font-size: 12px;
  }
  &:hover {
    border-radius: 0px 7px 7px 0px;
  }
}
</style>
